import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { 
    Grid, FormControl, InputLabel, OutlinedInput, InputAdornment, IconButton, Typography, Card, CardMedia,
    CardContent, CardActions, Button
} from '@mui/material';
import { MyContext } from '../MyContext';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import ShoppingCartCheckoutIcon from '@mui/icons-material/ShoppingCartCheckout';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import MapIcon from '@mui/icons-material/Map';
import axios from "axios";
import Helpers from "../Helpers";

const largura = window.innerWidth;
const altura = window.innerHeight;
let newWidth = '100%';

if(largura > 440 && largura <= 800){
    newWidth = '49%';
}else if(largura > 800 && largura <= 1200){
    newWidth = '32%';
}else if(largura > 1200){
    newWidth = '33%';
}

function Clientes(){
    const navigate = useNavigate();
    const { listaCarrinho } = useContext(MyContext);
    const [urlApi, setUrlApi] = useState(process.env.REACT_APP_URL_API);
    const [listaClientes, setListaClientes] = useState([]);
    const [listaFiltrada, setListaFiltrada] = useState([]);
    const [inputPesquisa, setInputPesquisa] = useState('');
    const [idFuncionario, setIdFuncionario] = useState(null);

    const getAuth = ()=>{
        const data = localStorage.getItem('userAuth');

        if(data != null){
            let user = JSON.parse(data);
            setIdFuncionario(user.id_funcionario);
        }
    };

    const getClientesApi = async(funcionario_id)=>{
        Helpers.loadingAlert('Atualizando lista de clientes');
        const rota = `${urlApi}/${funcionario_id}/tabelas`;
        const resposta = await axios.get(rota);
        const data = resposta.data;

        setListaClientes(data.clientes);
        setListaFiltrada(data.clientes);

        localStorage.setItem('empresa', JSON.stringify(data.empresa));
    };

    const handleFiltraCliente = (input)=>{
        Helpers.loadingAlert('Filtrando clientes');
        let registro = input;

        if(registro == ''){
            setInputPesquisa('');
            setListaFiltrada(listaClientes);
            
            return Helpers.toastAlert({
                title: 'Lista de clientes atualizada',
                icon: 'success'
            });
        }

        const resultado = listaClientes.filter(item => {
            let ds_registro = item.nm_fantasia;
            return ds_registro.toLowerCase().includes(registro.toLowerCase());
        });

        if(resultado.length > 0){
            setListaFiltrada(resultado);
        }else{
            setListaFiltrada(listaClientes);
            return Helpers.toastAlert({
                title: 'Nenhum registro encontrado.',
                icon: 'warning'
            });
        }

        setInputPesquisa(registro);
    };

    const formatPhoneNumber = (phone) => {
        if (!phone) return '';
        // Remove tudo que não for número
        const onlyNumbers = phone.replace(/\D/g, '');
        
        // Retorna apenas o número do celular (sem DDD)
        // Exemplo: de '34991999199' para '991999199'
        return onlyNumbers.length > 2 ? onlyNumbers.substring(2) : onlyNumbers;
    };

    const makeCall = (phoneNumber) => {
        const confirmar = window.confirm(`Deseja ligar para ${phoneNumber}?`);

        if (confirmar) {
            window.location.href = `tel:${phoneNumber}`;
        }
    };

    const openGoogleMaps = (address) => {
        if (!address) return;

        const url = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
        window.location.href = url;
    };

    const carrinhoCliente = (parceiro) => {
        localStorage.removeItem('clienteSelecionado');
        localStorage.setItem('clienteSelecionado', JSON.stringify({ 
            idCliente: parceiro.id,
            nmFantasia: parceiro.nm_fantasia 
        }));

        if(listaCarrinho.length > 0){  
            const existingItemIndex = listaCarrinho.findIndex(item => Number(item.idCliente) === Number(parceiro.id));

            if (existingItemIndex !== -1) { // Se o cliente estiver no state, faz a navegação para a lista de produtos.
                navigate('/produtos', { state: { idCliente: parceiro.id, nmFantasia: parceiro.nm_fantasia } });
            } else { // Se o item não estiver no state, mostra mensagem de erro.
                return Helpers.toastAlert({
                    title: "Para prosseguir com este cliente limpe o carrinho de pedidos.",
                    icon: 'error'
                });
            }
        }else{
            navigate('/produtos',  { state: { idCliente: parceiro.id, nmFantasia: parceiro.nm_fantasia }});
        }
    };

    const iconeCarrinho = (id_cliente) => {
        const existingItemIndex = listaCarrinho.findIndex(item => Number(item.idCliente) === Number(id_cliente));

        if (existingItemIndex !== -1) {
            return <AddShoppingCartIcon sx={{ fontSize: 24, color: 'green' }} />
        } else {
            return <ShoppingCartCheckoutIcon sx={{ fontSize: 24, color: 'rgba(0, 0, 0, 0.7)' }} />
        }
    };

    const storeUpdateCliente = (client) => {
        navigate('/clientes/cadastro', { state: { cliente: client, funcionario_id: idFuncionario } });
    };

    useEffect(() => {
        setTimeout(() => {
            getAuth();

            if(idFuncionario !== null){
                getClientesApi(idFuncionario);
            }

        }, 1000);
    }, [idFuncionario]);

    return (
        <Grid container rowSpacing={2}>
            <Grid size={{ xs: 12, md: 6 }} offset={{ md: 3 }} >
                <FormControl fullWidth variant="outlined" sx={{ borderRadius: 5, backgroundColor: '#f5f5f5' }}>
                    <InputLabel htmlFor="outlined-adornment-password">Pesquisar cliente</InputLabel>
                    <OutlinedInput
                        id="outlined-adornment-password"
                        type={'search'}
                        value={inputPesquisa}
                        onChange={(e) => setInputPesquisa(e.target.value)}
                        endAdornment={
                            <InputAdornment position="end">
                                <IconButton
                                    onClick={()=>handleFiltraCliente(inputPesquisa)}
                                    edge="end"
                                >
                                    <PersonSearchIcon />
                                </IconButton>
                                <IconButton
                                    onClick={()=>storeUpdateCliente(null)}
                                    edge="end"
                                    sx={{ marginLeft: 2 }}
                                >
                                    <PersonAddIcon />
                                </IconButton>
                            </InputAdornment>
                        }
                        label="Pesquisar cliente"
                    />
                </FormControl>
            </Grid>

            <Grid size={{ xs: 12, md: 12 }} sx={{ marginBottom: 1, borderBottom: '3px solid #DA0C16' }}>
                <Typography sx={{ fontWeight: 'bold' }}>{`${listaFiltrada.length} clientes encontrados`} </Typography>
            </Grid>

            <Grid container sx={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-around' }}>
            {
                (listaFiltrada.length > 0) &&
                listaFiltrada.map((item, index)=>{
                    let endereco_maps = `${item.ds_endereco}, ${item.nr_endereco}, ${item.ds_bairro}, ${item.ds_cidade}`;

                    return(
                        <Card key={index} sx={{ width: newWidth, display: 'flex', flexDirection: 'row' }}>
                            <CardContent sx={{ width: '80%', }}>
                                <Typography gutterBottom component="div">
                                    {item.nm_fantasia}
                                </Typography>

                                <Grid size={12} sx={{ display: 'flex', justifyContent: 'space-between', marginBottom: 1, }}>
                                    <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                        {`Cód: ${item.cd_parceiro}`}
                                    </Typography>
                                    <Typography variant="body2" sx={{ color: 'text.secondary' }} onClick={() => makeCall(formatPhoneNumber(item.ds_telefone))}>
                                        {item.ds_telefone}
                                    </Typography>
                                </Grid>

                                <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: 12, marginBottom: 1, }}>
                                    {`${item.ds_endereco}, ${item.nr_endereco}`}
                                </Typography>

                                <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: 12  }}>
                                    {`${item.ds_bairro} - ${item.ds_cidade}`}
                                </Typography>
                            </CardContent>

                            <CardActions sx={{ width: '20%', display: 'flex', flexDirection: 'column', justifyContent: 'space-around', alignItems: 'flex-end' }}>
                                <Button size="small" onClick={() => openGoogleMaps(endereco_maps)}>
                                    <MapIcon sx={{ color: 'rgba(0, 0, 0, 0.7)' }}/>
                                </Button>
                                <Button size="small" onClick={() => storeUpdateCliente(item)}>
                                    <BorderColorIcon sx={{ color: 'rgba(0, 0, 0, 0.7)' }}/>
                                </Button>
                                <Button size="small" onClick={() => carrinhoCliente(item)}>
                                    { iconeCarrinho(item.id) }
                                </Button>
                            </CardActions>
                        </Card>
                    )
                })
            }
            </Grid>
        </Grid>
    );
}

export default Clientes;